import { render } from "./DisplayNotificationsBase.vue?vue&type=template&id=ef8b7916"
import script from "./DisplayNotificationsBase.vue?vue&type=script&lang=js"
export * from "./DisplayNotificationsBase.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__